"use strict";

(function () {
  'use strict';

  angular.module('lr.Notifier').service('$lrNotifier', ['$timeout', function ($timeout) {
    var DEFAULTS = {
      hideDelay: 3000,
      toggle: false
    };
    this.activeContent = '';
    this.display = false;
    this.toggle = DEFAULTS.toggle;
    /**
     *
     * @param time
     * @returns {*}
     */

    this.hideDelay = function (time) {
      DEFAULTS.hideDelay = time;
      return this;
    };
    /**
     *
     * @param isToggle
     * @returns {*}
     */


    this.toggle = function (isToggle) {
      this.toggle = DEFAULTS.toggle = isToggle;
      return this;
    };
    /**
     * delay when the element gets hidden
     */


    this.delayHide = function () {
      $timeout(this.hide.bind(this), DEFAULTS.hideDelay);
    };
    /**
     *
     * @returns {*}
     */


    this.show = function () {
      this.display = true;

      if (!DEFAULTS.toggle) {
        this.delayHide();
      }

      return this;
    };
    /**
     *
     * @returns {*}
     */


    this.hide = function () {
      this.display = false;
      this.toggle = DEFAULTS.toggle = false;
      return this;
    };
    /**
     *
     * @param newContent
     * @returns {*}
     */


    this.content = function (newContent) {
      this.activeContent = newContent;
      return this;
    };
    /**
     *
     * @returns {*}
     */


    this.$get = function () {
      return this;
    };
  }]);
})();